import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

const BarChartInadimplenceCategoria = ({ categories }) => {
  const maxChars = 40;

  const categoryNames = categories.map((item) => item.categoria);
  const delinquencyPercentages = categories.map((item) => item.percentual_inadimplencia);
  const accumulatedPercentages = categories.map((item) => item.inadimplencia_acumulada);

  const truncatedCategoryNames = categoryNames.map((name) =>
    name.length > maxChars ? name.substring(0, maxChars) + '...' : name
  );

  const option = {
    title: {
      text: 'Inadimplência por Categoria',
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: (params) => {
        let tooltipContent = '';
        params.forEach((param, index) => {
          const categoryName = categoryNames[param.dataIndex];
          const value = param.value.toFixed(2);
          const label = index === 0 ? 'Inadimplência' : 'Inadimplência por Categoria';
    
          tooltipContent += `
            <div> Categoria: ${categoryName} </div>
            <div> ${label}: ${value}% </div>
          `;
        });
        return tooltipContent;
      },
    },
    
    legend: {
      data: [
        {name: 'Inadimplência', icon: 'circle'},
        {name: 'Inadimplência Acumulada', icon: 'circle'},
      ],
      right: '0',
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
    },
    yAxis: {
      type: 'category',
      data: truncatedCategoryNames,
      axisLabel: {
        formatter: (value) => {
          const originalName = categoryNames[truncatedCategoryNames.indexOf(value)];
          return `{title|${value}}`;
        },
        rich: {
          title: {
            width: '200px',
            overflow: 'truncate',
            ellipsis: '...',
          },
        },
      },
    },
    series: [
      {
        name: 'Inadimplência',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: (params) => Math.round(Number(params.value)) + '%',
        },
        itemStyle: {
          color: '#E04A4C',
        },
        emphasis: {
          focus: 'series',
        },
        data: delinquencyPercentages,
      },
      {
        name: 'Inadimplência Acumulada',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: (params) => Math.round(Number(params.value)) + '%',
        },
        itemStyle: {
          color: '#000',
        },
        emphasis: {
          focus: 'series',
        },
        data: accumulatedPercentages,
      },
    ],
  } as ChartOption;

  const chartHeight = Math.max(400, categories.length * 30);

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', padding: '20px 10px 0 10px' }} height={`${chartHeight}px`}>
      <Chart option={option} />
    </Box>
  );
};

export default BarChartInadimplenceCategoria;
